export default defineNuxtPlugin(() => {
  if (!import.meta.env.PROD) return

  // Google Tag Manager (production) — for test use GTM-TJKCFHHL
  const GTM_ID = 'GTM-54DCTNB3'
  const w = window as any
  w.dataLayer = w.dataLayer || []
  ;((w: any, d: Document, s: string, l: string, i: string) => {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement(s) as HTMLScriptElement
    const dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode?.insertBefore(j, f)
  })(w, document, 'script', 'dataLayer', GTM_ID)

  const auth = useState<any>('auth')
  const pushUserId = () => {
    const userId = auth.value?.userData?.user?.id
    if (!userId) return

    w.dataLayer = w.dataLayer || []
    w.dataLayer.push({ event: 'user_data', user_id: String(userId), debug_mode: true })
    w.dataLayer.push({ user_id: String(userId), debug_mode: true })
  }

  pushUserId()
  const router = useRouter()
  router.afterEach(() => pushUserId())
})
